import { Icon as IconifyIcon, type IconProps } from "@iconify/react";

const Icon = ({ icon, ...props }: { icon: string } & IconProps) => {
  const iconName = icon.includes(":") ? icon : `tabler:${icon}`;

  return <IconifyIcon icon={iconName} {...props} />;
};

export default Icon;
